var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from 'moment';
import React from 'react';
import { useReactToPrint } from 'react-to-print';
import LogoSvg from './logo-svg';
import { REPORT_TYPES, getUserFullName } from '../consts';
import { fixNum } from '../utils/general-utils';
import { isRTL, t } from '../multi-language/multi-lang.service';
function ReportHeader(_a) {
    var user = _a.user, type = _a.type, isPdf = _a.isPdf, refToPrint = _a.refToPrint, startDate = _a.startDate, endDate = _a.endDate, reportGeneratintgTime = _a.reportGeneratintgTime, _b = _a.timezoneOffset, timezoneOffset = _b === void 0 ? 999 : _b;
    var handlePrint = useReactToPrint({
        content: function () {
            return refToPrint.current;
        },
    });
    var isRtl = isRTL();
    var isMonthly = type === REPORT_TYPES.MONTHLY;
    var userFullName = getUserFullName(user);
    var reportCreationTime = reportGeneratintgTime ? moment(reportGeneratintgTime) : moment();
    var generatingDate = timezoneOffset !== 999 ? moment(reportCreationTime).utcOffset(timezoneOffset).format('MMM DD, YYYY - HH:mm A') : moment().format('MMM DD, YYYY - HH:mm A');
    var reportDateKeyTxt = t("header.measure_date".concat(endDate ? 's' : ''));
    var reportDateRange = "".concat(startDate, " ").concat(endDate ? "- ".concat(endDate) : '', " "); //timeZone????
    var getGmt = function () {
        var reportGmtTz = endDate ? user.time_zone : user.current_time_zone;
        reportGmtTz = fixNum(+reportGmtTz, 2);
        return (reportGmtTz || reportGmtTz === 0) && "(GMT ".concat(reportGmtTz > 0 ? "+ ".concat(reportGmtTz) : "".concat(reportGmtTz), ")");
    };
    var css = !isPdf ? {} : {
        header: {
            display: 'none',
        },
        wrapHeader: {
            direction: isRtl ? 'rtl' : 'ltr',
            width: '100%',
            padding: '0',
            margin: '0 10px 5px',
            zIndex: '10',
            backgroundColor: '#fff',
            top: 0,
            left: 0,
            printColorAdjust: 'exact',
            WebkitPrintColorAdjust: 'exact',
        },
        reportHeaderTop: {
            flexWrap: 'nowrap',
            display: 'flex',
        },
        wrapLogo: {
            flexBasis: '24%',
            paddingLeft: '5px',
        },
        infoSection: {
            textAlign: 'start',
            borderRight: isRtl ? 'solid 1px #efefef' : 'none',
            borderLeft: isRtl ? 'none' : 'solid 1px #efefef',
            paddingInlineStart: '2%',
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            marginInlineStart: '2%',
        },
        infoSectionP: {
            margin: 0,
            fontSize: '11px',
        },
        headerCard: {
            color: 'black',
            fontSize: '11px',
            backgroundColor: '#EFEFEF',
            padding: '3px 10px',
            printColorAdjust: 'exact',
            WebkitPrintColorAdjust: 'exact',
        },
        reportHeaderFooter: {
            margin: '0',
            display: 'flex',
            flexWrap: 'nowrap',
        },
        reportHeaderFooterSpan: {
            display: 'flex',
            alignItems: 'center',
        },
        reportDateTitle: {
            color: '#002D66',
            paddingRight: '1rem',
            fontWeight: 400,
        },
        placeDetailes: {
            paddingInlineStart: '5px',
        },
        reportTitle: {
            flexBasis: '28%',
            color: '#002D66',
            fontSize: '12px',
            fontWeight: 700,
        },
        patientInfo: {
            flexBasis: '72%',
            display: 'flex',
            justifyContent: 'space-between',
        },
        personalDetails: {
            paddingInlineStart: isMonthly ? '45px' : 0,
            fontSize: '11px',
            color: '#002D66',
            fontWeight: 'bold'
        },
        watchId: {
            margin: 0,
            fontSize: '11px',
            justifyContent: 'flex-end',
            minWidth: 'max-content',
            color: '#449B23',
        },
        reportAction: {
            display: 'none',
        }
    };
    return (React.createElement("div", { style: css.header, id: 'header' },
        React.createElement("div", { className: "wrap-header", style: css.wrapHeader },
            React.createElement("div", { style: css.reportHeaderTop, className: 'report-header-top' },
                React.createElement("div", { className: 'wrap-logo', style: css.wrapLogo },
                    React.createElement(LogoSvg, { width: isPdf ? 180 : 380, height: isPdf ? 40 : 63 })),
                React.createElement("div", { className: 'info-section size-15', style: css.infoSection },
                    React.createElement("p", { style: __assign(__assign({}, css.infoSectionP), { flexBasis: (endDate || reportGeneratintgTime) ? '100%' : 'auto' }), className: "report-date ".concat(endDate && 'flex-basis-100') },
                        React.createElement("span", { style: css.reportDateTitle, className: 'report-date-title' },
                            reportDateKeyTxt,
                            ":"),
                        React.createElement("span", { className: 'report-date-value' }, reportDateRange)),
                    (reportGeneratintgTime || endDate) && React.createElement("p", { style: css.infoSectionP, className: 'report-generating-date' },
                        React.createElement("span", { style: css.reportDateTitle, className: 'report-date-title' },
                            t('header.generate_date'),
                            ":"),
                        React.createElement("span", { className: 'report-date-value' }, generatingDate)),
                    React.createElement("p", { style: __assign(__assign({}, css.infoSectionP), css.placeDetailes), className: 'place-detailes ps-2' }, getGmt()))),
            React.createElement("div", { style: __assign(__assign({}, css.reportHeaderFooter), css.headerCard), className: "row header-card fs-4 report-header-footer" },
                React.createElement("span", { style: __assign(__assign({}, css.reportHeaderFooterSpan), css.reportTitle), className: 'report-title' }, t("".concat(type, ".title"))),
                React.createElement("div", { style: css.patientInfo, className: 'patient-info' },
                    React.createElement("span", { style: __assign(__assign({}, css.reportHeaderFooterSpan), css.personalDetails), className: 'personal-details' },
                        userFullName,
                        ", ",
                        user.id_number || user.idNumber),
                    React.createElement("span", { style: __assign(__assign({}, css.reportHeaderFooterSpan), css.watchId), className: "watch-id green-team" },
                        user.peripheralName || '0000000',
                        React.createElement("div", { style: css.reportAction, className: 'report-actions' },
                            React.createElement("img", { className: 'pointer ps-3', alt: "print", src: require("../assets/icons/print.svg").default, height: "24px", onClick: handlePrint }))))))));
}
export default ReportHeader;
//# sourceMappingURL=report-header.js.map